export { default as GeneralDiscount } from './GeneralDiscount/GeneralDiscount'
export { default as ProductBonus } from './ProductBonus/ProductBonus'
export { default as Discount } from './Discount/Discount'
export { default as SetPrice } from './SetPrice/SetPrice'
